import { FieldArray, useFormikContext, getIn } from 'formik'
import { TariffListItem } from './TariffListItem'
import { LinkButton } from 'shared/components/LinkButton'
import { TariffListWrapper, TimeSlotSettingsWrapper } from './style'

import { TimeSlotSettings } from '../model/generalData'
import { FormikInput } from 'shared/components/FormikInput'

type Tariff = {
    hours: number
    price: number
}

interface TariffListProps {
    isEditable: boolean
}

function getIsHoursEditable(hour: number, index: number, isEditable: boolean): boolean {
    if(hour === 1 && index === 0) return false

    return isEditable
}

export function TariffList({ isEditable }: TariffListProps) {
    const { values } = useFormikContext<any>()

    const tariffs = getIn(values, 'ad_price_info.tariffs') as Tariff[] || []

    return (
        <TariffListWrapper>
            <FieldArray name='ad_price_info.tariffs'>
                {({ push, remove }) => {
                    return (
                        <>
                            {tariffs.map((tariff, index) => (
                                <TariffListItem
                                    index={index}
                                    key={index}
                                    tariff={tariff}
                                    remove={remove}
                                    isHoursEditable={getIsHoursEditable(tariff.hours, index, isEditable)}
                                    isPricePerHoursEditable={isEditable}
                                    isRequired={tariff.hours === 1}
                                />
                            ))}
                            {isEditable && (
                                <LinkButton
                                    disabled={!isEditable}
                                    type='button'
                                    onClick={() => push({ hours: 0, price: 0 })}
                                >
                                    Добавить еще тариф
                                </LinkButton>
                            )}
                        </>
                    )
                }}
            </FieldArray>
            <TimeSlotSettingsWrapper>
                {TimeSlotSettings.map((item, itemIndex) => {
                    return (
                        <FormikInput
                            key={itemIndex}
                            name={item.name}
                            label={item.label}
                            placeholder={item.placeholder}
                            type={item.type}
                            disabled={!isEditable || (item.disabled ?? false)}
                            value={values[item.name]}
                            maskConfig={item.maskConfig}
                            className='inputForm'
                            $afterIcon='clearInput'
                        />
                    )
                })}
            </TimeSlotSettingsWrapper>
        </TariffListWrapper>
    )
}
